export default __webpack_public_path__ + "static/media/api_gateway.53a09fd9.svg";